export const fkQueryList = function fkQueryList(params) {
    vm.$network.post('/p/cs/QueryList', vm.$urlSearchParams({
        searchdata: params.searchObject
    }), {
        serviceId: params.serviceId
    }).then((res) => {
        if (typeof params.success === 'function') {
            params.success(res);
        }
    });
};

// export const fkFuzzyquerybyak = function fkFuzzyquerybyak(params) {
//   vm.$network.post('/p/cs/fuzzyquerybyak', vm.$urlSearchParams({
//     searchdata: params.searchObject
//   }), {
//     serviceId: params.serviceId
//   }).then((res) => {
//     if (typeof params.success === 'function') {
//       res.data.data = res.data && res.data.data;
//       params.success(res);
//     }
//   });
// };

export const fkFuzzyquerybyak = async function fkFuzzyquerybyak(params) {
    let res = vm.$network.post('/p/cs/fuzzyquerybyak', vm.$urlSearchParams(params))
    return res
}